import React from 'react'
import PropTypes from 'prop-types';

import './imagePanel.styl'
class ImagePanel extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        data: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.instanceOf(undefined)
        ]),
        x: PropTypes.number,
        y: PropTypes.number,
        width: PropTypes.number,
        height: PropTypes.number
    }

    draw(props={}) {
        const {data=false} = props
        if(!data) return

        const img = new Image();
        const ctx = this.image.getContext('2d');
        ctx.clearRect(0, 0, this.image.width, this.image.height);
        // ctx.mozImageSmoothingEnabled = false;
        // ctx.webkitImageSmoothingEnabled = false;
        // ctx.msImageSmoothingEnabled = false;
        // ctx.imageSmoothingEnabled = false;
        img.onload = () => {
            const { x=0, y=0, width=this.image.width, height=this.image.height} = props
            this.image.width = width
            this.image.height = height
            //drawImage(image, sourceX, sy, sWidth, sHeight, destX, dy, dWidth, dHeight);
            ctx.drawImage(img, x, y, width, height)//, 0, 0, width, height)
            this.setState({});
        };
        img.src = data;
    }

    componentDidMount() {
        this.draw(this.props)
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.draw(nextProps)
    }

    render() {
        let {data= false, className=false} = this.props;
        if(!data) {
            return <div className="empty"></div>
        }
        return <div className={'form image-panel' + (className ? ' ' + className : '')}>
            <canvas ref={input => this.image = input} />
        </div>
    }
}

export default ImagePanel
